import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import clsx from 'clsx';
import Typography from '@mui/material/Typography';
import { Translation } from '../Translation';
import themedErrorMessageStyles from './themedErrorMessage.styles';
/**
 * Error message component that supports translation and MUI theming.
 */
const ThemedErrorMessage = ({ message, error, fullPage, center = true, icon = true, redMessage = false, }) => {
    const styles = themedErrorMessageStyles({
        fullPage: !!fullPage,
        redMessage: !!redMessage,
    });
    const mainMessage = useMemo(() => {
        if (message && typeof message === 'string') {
            return _jsx(Translation, { id: message }, void 0);
        }
        if (message) {
            return message;
        }
        if (error?.message) {
            return error.message;
        }
        if (error instanceof Array) {
            return error.map(err => err.message).join(', ');
        }
        return _jsx(Translation, { id: "common.generalError" }, void 0);
    }, [message, error]);
    const secondaryMessage = useMemo(() => {
        if (message && error?.message) {
            return error.message;
        }
        if (error instanceof Array) {
            return error.map(err => err.message).join(', ');
        }
        return '';
    }, [message, error]);
    return (_jsx("div", { className: clsx({ [styles.root]: true, [styles.centered]: center }), children: _jsxs("div", { className: styles.errorHeader, "data-test": "error:themed", children: [icon && (_jsx("div", { className: styles.iconContainer, children: _jsx("div", { className: styles.icon }, void 0) }, void 0)), _jsxs("div", { className: styles.message, children: [_jsx(Typography, { variant: "body1", "data-test": "error:message", children: mainMessage }, void 0), _jsx(Typography, { className: styles.secondaryMessage, variant: "body2", "data-test": "error:secondary-message", children: secondaryMessage }, void 0)] }, void 0)] }, void 0) }, void 0));
};
export default ThemedErrorMessage;
//# sourceMappingURL=ThemedErrorMessage.js.map